import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// In browser, during webpack or browserify bundling, this module will be replaced by 'events'
// https://github.com/Gozala/events
import { EventEmitter } from "events";
/**
 * States for Batch.
 */

var BatchStates;

(function (BatchStates) {
  BatchStates[BatchStates["Good"] = 0] = "Good";
  BatchStates[BatchStates["Error"] = 1] = "Error";
})(BatchStates || (BatchStates = {}));
/**
 * Batch provides basic parallel execution with concurrency limits.
 * Will stop execute left operations when one of the executed operation throws an error.
 * But Batch cannot cancel ongoing operations, you need to cancel them by yourself.
 */


export var Batch = /*#__PURE__*/function () {
  /**
   * Creates an instance of Batch.
   * @param concurrency -
   */
  function Batch() {
    var concurrency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

    _classCallCheck(this, Batch);

    /**
     * Number of active operations under execution.
     */
    this.actives = 0;
    /**
     * Number of completed operations under execution.
     */

    this.completed = 0;
    /**
     * Offset of next operation to be executed.
     */

    this.offset = 0;
    /**
     * Operation array to be executed.
     */

    this.operations = [];
    /**
     * States of Batch. When an error happens, state will turn into error.
     * Batch will stop execute left operations.
     */

    this.state = BatchStates.Good;

    if (concurrency < 1) {
      throw new RangeError("concurrency must be larger than 0");
    }

    this.concurrency = concurrency;
    this.emitter = new EventEmitter();
  }
  /**
   * Add a operation into queue.
   *
   * @param operation -
   */


  _createClass(Batch, [{
    key: "addOperation",
    value: function addOperation(operation) {
      var _this = this;

      this.operations.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _this.actives++;
                _context.next = 4;
                return operation();

              case 4:
                _this.actives--;
                _this.completed++;

                _this.parallelExecute();

                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                _this.emitter.emit("error", _context.t0);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      })));
    }
    /**
     * Start execute operations in the queue.
     *
     */

  }, {
    key: "do",
    value: function () {
      var _do2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.operations.length === 0)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", Promise.resolve());

              case 2:
                this.parallelExecute();
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  _this2.emitter.on("finish", resolve);

                  _this2.emitter.on("error", function (error) {
                    _this2.state = BatchStates.Error;
                    reject(error);
                  });
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _do() {
        return _do2.apply(this, arguments);
      }

      return _do;
    }()
    /**
     * Get next operation to be executed. Return null when reaching ends.
     *
     */

  }, {
    key: "nextOperation",
    value: function nextOperation() {
      if (this.offset < this.operations.length) {
        return this.operations[this.offset++];
      }

      return null;
    }
    /**
     * Start execute operations. One one the most important difference between
     * this method with do() is that do() wraps as an sync method.
     *
     */

  }, {
    key: "parallelExecute",
    value: function parallelExecute() {
      if (this.state === BatchStates.Error) {
        return;
      }

      if (this.completed >= this.operations.length) {
        this.emitter.emit("finish");
        return;
      }

      while (this.actives < this.concurrency) {
        var operation = this.nextOperation();

        if (operation) {
          operation();
        } else {
          return;
        }
      }
    }
  }]);

  return Batch;
}();